<div class="lv-notification" *ngFor="let item of notificationService.items$ | async; index as i" @triggerChildAnimation>
  <lv-notification-item
      [notificationItem]="item"
      [notificationId]="i"
      @slideIn
      @slideOut
  >
  </lv-notification-item>
</div>
